import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { ObligationPeriodDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-obligationperiod-container',
  templateUrl: './obligationperiod-container.component.html',
  styleUrls: ['./obligationperiod-container.component.scss']
})
export class ObligationPeriodContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  obligationperiods$: Observable<ObligationPeriodDto[]>;
  loading: boolean;
  isLoadingObligationPeriod$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingObligationPeriod$ = this.gatwayFacade.isLoadingGateway("ObligationPeriod");
    this.obligationperiods$ = this.gatwayFacade.loadGateway("ObligationPeriod");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteObligationPeriod(deletedValue: any) {
    this.gatwayFacade.remove("ObligationPeriod", deletedValue);
  }


// this method control both the create and update

  onSubmitObligationPeriod(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.ObligationPeriods;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllObligationPeriod = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllObligationPeriod.push(pullData[i]);
    }
  }

// check if the addAllObligationPeriod array is not empty, then dispatch the data to the store
   if(addAllObligationPeriod.length > 0) {
    this.gatwayFacade.add('ObligationPeriod', addAllObligationPeriod);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('ObligationPeriod', allUpdates, ['id']);
  }

   }


}
